// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"e8e66302","29":"2149f6a4","108":"b02b4881","121":"a24b532a","135":"84908ca9","406":"3375ac04","661":"463d7419"}[chunkId] + ".chunk.js";
};